export default __webpack_public_path__ + "static/media/10.5066cf5a.png";